import { render, staticRenderFns } from "./FormController.vue?vue&type=template&id=6d7380f1&"
import script from "./FormController.vue?vue&type=script&lang=js&"
export * from "./FormController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports